module.exports = __webpack_public_path__ + "img/redo-upload.037f461a.svg";